<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UpdatePassword" });
import Form from "../../../../components/form/Form.svelte";
import { Paragraph } from "../../../../typography/index.js";
import { InputPassword } from "../../../user/index.js";
import Button from "../../../../elements/button/Button.svelte";
import { AUTHENTICATION } from "../../services/store.js";
import { QUERY_STATE } from "../../../../stores/query.js";
import * as API from "../../services/api.js";
import Heading from "../../../../typography/heading/Heading.svelte";
let error = "";
$: token = QUERY_STATE.getParameter("token") ?? "";
const onSubmit = async () => {
    if (token === void 0) {
        error = "Token is missing. Please request another link and try again.";
        return;
    }
    if ($AUTHENTICATION.password === void 0) {
        error = "Please provide a password and try again.";
        return;
    }
    const RESPONSE = await API.updatePasswordViaToken({ password: $AUTHENTICATION.password }, token);
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
    }
    $AUTHENTICATION.password = "";
    QUERY_STATE.removeParameter("token");
};
</script>

{#if token !== undefined}

    <Form { onSubmit } { error } id = 'update-password'>

        {#if Boolean(error)}
            <Paragraph label = { error } css = 'mt-4' color = 'error' />
        {/if}

        <Heading size = 'xs' css = 'mt-4'>Update Password</Heading>

        <input
            type = 'email'
            value = { $AUTHENTICATION.email }
            autocomplete = 'username'
            style = 'display: none;'
        />

        <InputPassword
            bind:value = { $AUTHENTICATION.password }
            autocomplete = 'new-password'
            placeholder = 'New Password'
            label = { null }
        />

        <svelte:fragment slot = 'footer'>
            <Button type = 'submit' label = 'Update Password' />
        </svelte:fragment>

    </Form>

{:else}
    <Paragraph label = 'component.session.update_password.error.no_token' />
{/if}